import { Component, OnInit, AfterViewChecked, AfterViewInit, ChangeDetectorRef } from '@angular/core';
import { Router } from '@angular/router';
import { DialogService } from 'ng2-bootstrap-modal';
import { Observable } from 'rxjs/Rx';

import { OPCOVIEWLABELS, SHAREDCONSTANTS } from '../_constants/constants';
import { AgentProfile } from '../_models/agent.profile';
import { AgentProfileService } from '../_services/agent.profile.service';

import { TranslatePipe } from '../shared/translate/translate.pipe';
import { TranslateService } from '../_services/translate.service';
import { NotificationDialogComponent } from './../notification/notification.dialog.component';
import { LoaderService } from '../_services/loader.service';

declare var $: any;

@Component({
  templateUrl: './opco-form.component.html',
  providers: [TranslatePipe]
})

export class OpcoFormComponent implements OnInit, AfterViewInit {
  opcoviewlabels = OPCOVIEWLABELS;
  agentProfileService: AgentProfileService;

  selectedOpco: string = "";
  selectedCountry: string = "";
  flagOpcos: any = {};
  flagCountries: any = {};
  selectOpcoError: Boolean = false;

  constructor(private router: Router, private ds: DialogService, agentProfileService: AgentProfileService, private translatePipe: TranslatePipe, private translate: TranslateService, private cdRef: ChangeDetectorRef, private loaderService: LoaderService) {
    this.agentProfileService = agentProfileService;
  }

  ngOnInit(): void {

    if (parseInt($('.modal').length) > 1 && parseInt($('.alert-danger').length) > 1) {

      $(".modal").each(function(i, e) {        
        if (i > 0) {
          $(this).remove();
        }
      });
    }

    let selectedOpco = localStorage.getItem('opco');
    let selectedCountry = localStorage.getItem('country');

    if (selectedOpco && selectedOpco !== null) {
      this.selectedOpco = selectedOpco;      
    }
    if ((selectedOpco && selectedOpco !== null) && (selectedCountry && selectedCountry !== null)) {
      this.selectedOpco = selectedOpco;
      this.selectedCountry = selectedCountry;
    }

    localStorage.setItem('searchData', JSON.stringify({}));
    localStorage.setItem('opco-header', "");

  }


  ngAfterViewInit() {

    setTimeout(() => {    

    if (parseInt($('.modal').length) > 1 && parseInt($('.alert-danger').length) > 1) {
    
      $(".modal").each(function(i, e) {          
          if (i > 0) {
            $(this).remove();
          }
        });
      }      
    }, 500);
  }



  loadCountryDropDown(selectedCountry) {
    if (this.agentProfileService.loadAgentProfile() !== undefined) {
      if (this.agentProfileService.loadAgentProfile().getAvailableCountries(this.selectedOpco).length && this.selectedOpco !== '') {

        for (let item of this.agentProfileService.loadAgentProfile().getAvailableCountries(this.selectedOpco)) {

          this.flagCountries[item] = item.toUpperCase();
        }



        $('#lang-select-country').attr('data-selected-country', selectedCountry);



        $('#lang-select-country').flagStrap({
          countries: this.flagCountries,
          inputName: 'opco-country',
          onSelect: (value, element) => {


            if (value === '' || value === null) {
              this.selectOpcoError = true;
              return;
            }

            this.selectOpcoError = false;
            localStorage.setItem('country', value);



          },
          placeholder: false
        });


        localStorage.setItem('country', selectedCountry);
      } else {
        localStorage.setItem('country', "");
      }






      //this.selectedCountry = selectedCountry;

    }
  }



  ngAfterViewChecked(): void {


    if (this.agentProfileService.loadAgentProfile() !== undefined) {
      if (this.agentProfileService.loadAgentProfile().getAvailableOpcos().length) {

        for (let item of this.agentProfileService.loadAgentProfile().getAvailableOpcosValue()) {

          this.flagOpcos[item] = item.toUpperCase();
        }




        let selectedOpco = localStorage.getItem('opco');
        let selectedCountry = localStorage.getItem('country');

        if (selectedOpco && selectedOpco !== null) {
          this.selectedOpco = selectedOpco;
        }
        if ((selectedOpco && selectedOpco !== null) && (selectedCountry && selectedCountry !== null)) {
          this.selectedOpco = selectedOpco;
          this.selectedCountry = selectedCountry;
        }

        localStorage.setItem('searchData', JSON.stringify({}));
        localStorage.setItem('opco-header', "");



        $('#lang-select-opco').attr('data-selected-country', this.selectedOpco);

        if (this.selectedCountry && (this.selectedCountry !== undefined || this.selectedCountry !== "")) {
          //$('#lang-select-country').attr('data-selected-country', this.selectedCountry);

          this.loadCountryDropDown(this.selectedCountry)

        }

        $('#lang-select-opco').flagStrap({
          countries: this.flagOpcos,
          inputName: 'opco',
          onSelect: (value, element) => {


            if (value === '' || value === null) {
              this.selectOpcoError = true;



                //VICC-622
                localStorage.setItem('country', "");
                localStorage.setItem('opco', "");
                this.selectedCountry = ""
                this.selectedOpco = ""

              return;
            }

            this.selectedOpco = value;
            this.selectOpcoError = false;

            //this.selectOpcoError = (this.selectedOpco === '' || this.selectedOpco === null) ? true : false;
            

            localStorage.setItem('opco', this.selectedOpco);


            if (this.selectedOpco.toLowerCase() !== "nv") {

              localStorage.setItem('country', "");
              this.selectedCountry = ""

            } else {

              this.loaderService.display(true);

              setTimeout(() => {                

                this.loadCountryDropDown(this.agentProfileService.loadAgentProfile().getAvailableCountries("nv")[0]);
                //this.loadCountryDropDown(this.agentProfileService.loadAgentProfile().getAvailableOpcosValue()[0]);




                this.loaderService.display(false);

              }, 1000);
            }
          },
          placeholder: {
            value: '',
            text: this.translatePipe.transform('HEADING', 'OPCOVIEWLABELS')
          }
        });
      }
    }




    

    $("#lang-select-opco .dropdown-menu").find('li a:first').text(this.translatePipe.transform('HEADING', 'OPCOVIEWLABELS'));

    //$(".flagstrap-placeholder").parents('span').text(this.translatePipe.transform('HEADING', 'OPCOVIEWLABELS'));
  }

  onChange(event): void {

    if (event.target.value === 'Select Market') {
      this.selectedOpco = "";
      return;
    }

    var that = this;

    const newVal = event.target.value;
    this.selectedOpco = newVal;

    localStorage.setItem('opco', event.target.value);

    let lang = this.selectedOpco;

    if (newVal !== "nv") {

      localStorage.setItem('country', "");
      //localStorage.setItem('language',this.selectedOpco);

      //lang = this.selectedOpco; 

      //this.translate.use(lang);     
    } else {

      this.loaderService.display(true);

      setTimeout(() => {

        localStorage.setItem('country', $("#opco-country-dropdown option:first").val());
        //localStorage.setItem('language',$("#opco-country-dropdown option:first").val());  

        //lang = $("#opco-country-dropdown option:first").val();
        this.selectedCountry = $("#opco-country-dropdown option:first").val();

        //this.translate.use(lang);
        this.loaderService.display(false);

      }, 1000);
    }
  }

  changeCountry(event): void {

    let lang = event.target.value

    //localStorage.setItem('language',lang);
    localStorage.setItem('country', event.target.value);

    //this.translate.use(lang);    
  }



  saveTask(value: any) {

    let opcoName = '';
    let opcoCountry = '';

    opcoName = this.selectedOpco; //value['opco-name'];

    if (opcoName === '') {
      
      this.selectOpcoError = true;

      // this.ds.addDialog(NotificationDialogComponent, {
      //   success: false,
      //   message: this.translatePipe.transform('INVALID_OPCO_ERROR', 'GENERIC_MESSAGE')
      // });
      return;
    }

    if (this.selectedCountry) {
      opcoCountry = this.selectedCountry;
    }

    if (opcoCountry === "" || typeof opcoCountry === "undefined") {

      localStorage.setItem('opco-header', opcoName);

      this.router.navigate(['/' + opcoName + '/search']);
    } else {

      localStorage.setItem('opco-header', opcoName + "-" + opcoCountry);

      this.router.navigate(['/' + opcoName + '/search/' + opcoCountry]);
    }

  }

  // saveTask(value: any) {

  //   let opcoName = '';
  //   let opcoCountry = '';

  //   opcoName = value['opco-name']; 

  //   if(opcoName === 'Select Country'){
  //     this.ds.addDialog(NotificationDialogComponent, {
  //         success: false,
  //         message: this.translatePipe.transform('INVALID_OPCO_ERROR','GENERIC_MESSAGE')                    
  //     });
  //     return;
  //   }   

  //   if($('#opco-country-dropdown').length){
  //     opcoCountry = $('#opco-country-dropdown').val();
  //   }

  //   if(opcoCountry === "" || typeof opcoCountry === "undefined"){ 

  //       localStorage.setItem('opco-header',opcoName);

  //       this.router.navigate(['/' + opcoName + '/search']);
  //   }
  //   else{

  //     localStorage.setItem('opco-header',opcoName+"-"+opcoCountry);

  //     this.router.navigate(['/' + opcoName + '/search/' + opcoCountry]);
  //   }

  // }
}



// WEBPACK FOOTER //
// ./src/app/opco/opco-form.component.ts